<template>
  <Unauthenticated>
    <div class="top-margin">
      <form v-if="!code" v-on:submit.prevent="login">
        <img src="/beamylogo_white.svg" />
        <h1 class="title">{{ title }}</h1>
        <div class="error" v-if="errors && errors.email">{{ errors.email.join(", ") }}</div>
        <input name="email" v-model="email" placeholder="Email Address" autocomplete="username" />

        <input type="password" name="current-password" v-model="password" placeholder="Password" />
        <!-- <div class="error" v-if="errors && errors.password">Password {{ errors.password.join(", ") }}</div> -->

        <div class="error" v-if="errors && errors.all">{{ errors.all }}</div>
        <button type="submit" value="Log In" class="primary w-100 action-colour">Log in</button>

        <button v-if="isBridge" type="button" @click="signup" value="Sign Up" class="btn btn-primary btn-lg btn-dark">Sign Up</button>
        <button v-if="isPOS || isCompanion" @click.stop.prevent="code = !code" class="btn btn-primary btn-lg btn-dark">Log in using code</button>
        <span v-if="isPOS">
          <p>If you haven't got an account with us, you can signup at</p>
          <a href="https://bridge.beamy.nz" class="bridge-link" target="_blank" rel="noopener noreferrer">bridge.beamy.nz</a>
        </span>
      </form>
      <form v-if="code && (isPOS || isCompanion)" v-on:submit.prevent="codeLogin" class="form-container">
        <img src="/beamylogo_white.svg" />
        <h1>{{ title }}</h1>
        <div class="digits form">
          <input
            v-for="(digit, idx) in digits"
            :key="idx"
            class="digit-input"
            type="text"
            inputmode="numeric"
            name="code"
            maxlength="1"
            v-model="digits[idx]"
            @input="handleInput(idx, $event)"
            @keydown="handleKeydown(idx, $event)"
            @paste="onPaste(event)"
            :ref="`digitInput${idx}`"
            :autofocus="idx === 0" />
        </div>
        <div class="footer">
          <button type="submit" class="btn btn-primary btn-lg action-colour">Login</button>
          <button @click.stop.prevent="code = !code" class="btn btn-primary btn-lg">Log in using credentials</button>
        </div>
      </form>
    </div>
    <div class="loading-spinner" v-if="loading">
      <LoadingSpinner :spinnerMessage="'Retreiving Data...'" />
    </div>
  </Unauthenticated>
</template>

<script>
import { Unauthenticated, LoadingSpinner } from "@monolith/components";
import { api } from "@monolith/helpers";

export default {
  name: "Login",
  components: { Unauthenticated, LoadingSpinner },
  data() {
    return {
      errors: {},
      email: null,
      password: null,
      code: false,
      digits: ["", "", "", "", "", ""],
      loading: false,
      title: process.env.VUE_APP_FEATURE_FLAGS,
    };
  },

  computed: {
    isBridge() {
      return this.title == "bridge";
    },

    isPOS() {
      return this.title == "pos";
    },

    isCompanion() {
      return this.title == "companion";
    },

    isGeo() {
      return this.title == "geo";
    },

    isMon() {
      return this.title == "mon";
    },

    codeSubmitted() {
      return this.digits.join("");
    },
  },

  mounted() {
    // Clear local storage on the login page to ensure a clean state
    localStorage.clear();
  },

  methods: {
    signup() {
      this.$router.push("/signup");
    },

    async codeLogin() {
      let result = await api.device_login(parseInt(this.codeSubmitted));
      window.localStorage.setItem("token", result.jwt_token);
      this.loading = true;
      if (result == "error") {
        this.errors = "Login Failed";
        this.loading = false;
        return;
      }

      if (this.isCompanion) {
        this.$store.dispatch("companyIDAction", result.data.company);
        window.localStorage.setItem("company", result.data.company);
        window.localStorage.setItem("site", result.data.site);
        window.localStorage.setItem("station", result.data.station);
        this.$router.push({ path: "/companion" });
      } else {
        this.$store.dispatch("setToken", result.jwt_token);

        const company = await api.get('/api/company/get_pos');
        window.localStorage.setItem("company", result.data.company);
        window.localStorage.setItem("sites", JSON.stringify(company.rows[0].value.sites));
        window.localStorage.setItem("stations", JSON.stringify(company.rows[0].value.stations));
        window.localStorage.setItem("theme", JSON.stringify(company.rows[0].value.theme));
        api.loadTheme(company.rows[0].value.theme);

        window.localStorage.setItem("site", result.data.site);
        this.$store.dispatch("setSite", result.data.site);

        window.localStorage.setItem("station", result.data.station);
        this.$store.dispatch("setStation", result.data.station);

        this.$router.push({ path: "/store" });
      }
      this.loading = false;
    },

    handleInput(idx, event) {
      let current = event.target;
      if (this.digits[idx].length == 1 && idx < this.digits.length - 1) {
        current.nextElementSibling.focus();
      }
    },

    handleKeydown(idx, event) {
      let current = event.target;
      if (event.key == "Backspace" && this.digits[idx] == "" && idx > 0) {
        current.previousElementSibling.focus();
      }
    },

    async onPaste() {
      let paste = await navigator.clipboard.readText();
      let pasteArray = paste.split("");
      if (pasteArray.length !== 6) {
        return;
      }
      pasteArray.forEach((digit, idx) => {
        this.digits[idx] = digit;
      });
    },

    async login() {
      this.errors = {};
      try {
        let result = await api.login(this.email, this.password);
        this.loading = true;
        if (result.email == "unauthorized") {
          this.loading = false;
          return;
        }
        window.localStorage.setItem("token", result.jwt_token);
        /* set the global JWT token */
        if (this.isPOS) {
          this.$store.dispatch("setToken", result.jwt_token);
        }

				const get = this.isPOS || this.isCompanion ? "get_pos" : "get_mon";
				const company = await api.get('/api/company/' + get);
        window.localStorage.setItem("company", result.company);
        window.localStorage.setItem("sites", JSON.stringify(company.rows[0].value.sites));
        window.localStorage.setItem("stations", JSON.stringify(company.rows[0].value.stations));
        window.localStorage.setItem("theme", JSON.stringify(company.rows[0].value.theme));
        api.loadTheme(company.rows[0].value.theme);
        // this.$.appContext.config.globalProperties.token = result.jwt_token;

        if (this.isCompanion) {
          this.$store.dispatch("tokenAction", result.jwt_token);
          this.$store.dispatch("companyIDAction", result.company);
          this.$router.push({ path: "/chooseStore" });
        } else if (this.isPOS) {
          this.$router.push({ path: "/choose" });
        } else if (this.isBridge) {
          this.$store.dispatch("updateGeoSettings");
          this.$router.push({ path: "/dashboard" });
        } else if (this.isGeo) {
          this.$store.dispatch("updateGeoSettings");
          this.$router.push({ path: "/choose-driver" });
        } else if (this.isMon) {
          this.$store.dispatch("tokenAction", result.jwt_token);
          this.$store.dispatch("companyIDAction", result.company);
          this.$router.push({ path: "/chooseStore" });
        }
      } catch (error) {
        Object.keys(error).map((code) => {
          console.log(error, code, this.errors)
          this.errors[code] = [error[code]];
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.loading-spinner {
  background-color: var(--opacity-background);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}

.title {
  text-transform: uppercase;
  text-align: center;
}

.container {
  margin-top: 0;
}

form {
  border-radius: 0.5rem;
  max-width: 400px;
  min-width: 400px;
  padding: 3rem;
  margin: 0px auto;
  margin-top: 0.5rem;
  position: relative;
  background-color: var(--tertiary-colour);
  font-size: 1em;
  box-shadow: var(--box-shadow);
  img {
    width: 100%;
  }

  .bridge-link {
    align-items: center;
    justify-content: center;
    text-align: center;
    display: flex;
  }

  p {
    text-align: center;
  }

  a {
    color: var(--text-colour);
    text-decoration: none;
  }

  h1 {
    color: var(--action-colour);
    margin: 0 0 1rem 0;
  }

  .digits {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .digit-input {
      text-align: center;
      width: 3rem;
      height: 4rem;
      margin: 0.5rem;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
    }
  }

  .error {
    display: block;
    margin-bottom: 1em;
    color: #ff8197;
    text-transform: capitalize;
  }

  //a:v
  button {
    margin: 0.5rem;
    margin-left: 0px !important;
    padding: 1rem;
    width: 100%;
    background-color: lavender;
    font-weight: bolder;
    border-radius: 5px;
    background-color: var(--action-colour);
    color: var(--primary-colour);
    box-shadow: none !important;
    &:active {
      box-shadow: none;
      scale: 0.99;
    }
  }

  .btn-dark {
    background-color: var(--primary-colour);
    color: var(--text-colour);
  }

  input,
  button {
    font-size: 1rem;
    border: none;
  }
  input {
    font-size: 1rem;
    box-sizing: border-box;
    padding: 1rem !important;
    width: 100% !important;
    border-radius: 5px;
    box-shadow: var(--box-shadow);
  }

  p.or {
    text-align: center;
  }

  .btn-outline-info:hover {
    background-color: inherit;
  }
}

form input {
  position: relative;
  margin-bottom: 1rem;
}

form input,
form button {
  display: block;
}

.password {
  display: block;
  text-align: right;
  font-size: 0.8em;
  margin-top: 10px;
}

@media screen and (max-width: 840px) {
  .top-margin {
    max-width: 100% !important;
    form {
      border: none;
      padding: 2rem;
      max-width: 50%;
      min-width: 80% !important;
    }
  }
}
</style>
